import { useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import FeaturedTopics from "./components/FeaturedTopics";
import TopicSquare from "./components/TopicSquare";
import OpinionArena from "./components/OpinionArena";
import HotRanking from "./components/HotRanking";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import ContactSection from "./components/ContactSection";
import { allTopics, faqs } from "@/mocks/spotlight";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

const collectionSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "黑料看点 · 热门话题讨论合集",
  description: "聚焦网络热点话题讨论，汇聚争议热评与不同立场的观点。",
  inLanguage: "zh-CN",
  mainEntity: {
    "@type": "ItemList",
    itemListElement: allTopics.slice(0, 8).map((topic, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: topic.title,
    })),
  },
};

export default function Home() {
  const [query, setQuery] = useState("");

  const handleSearch = (value: string) => {
    setQuery(value);
    document.getElementById("square")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <Hero onSearch={handleSearch} />
        <FeaturedTopics />
        <TopicSquare query={query} setQuery={setQuery} />
        <OpinionArena />
        <HotRanking />
        <FaqSection />
        <BrandSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionSchema) }}
      />
    </div>
  );
}